'use client';

import { useUser } from '@auth0/nextjs-auth0/client';
import { useSplitTreatments } from '@splitsoftware/splitio-react';

export const useFeatureFlag = (featureFlag: string) => {
  const { user } = useUser();

  const { treatments, isReady } = useSplitTreatments({
    names: [featureFlag],
    attributes: {
      email: user?.email ?? '',
    },
  });
  let config = null;

  try {
    const featureFlagConfig = treatments[featureFlag]?.config;

    if (featureFlagConfig) {
      config = JSON.parse(featureFlagConfig);
    }
  } catch (e) {
    console.error(e);
  }

  return {
    treatment: treatments[featureFlag]?.treatment,
    isReady,
    config,
  };
};
